const tournamentPrizePool = {
  usd: 0,
  lottery: 3200,
};

const currentLotterySeason = 10;

export { currentLotterySeason, tournamentPrizePool };
